import { useEffect, useMemo, useState } from 'react';
import { Checkbox, Modal, Text } from '@shopify/polaris';

export function ResetDefaultsModal({
  open,
  targetTitle,
  settings,
  busy,
  onClose,
  onPreview,
}: {
  open: boolean;
  targetTitle: string;
  settings: any[];
  busy?: boolean;
  onClose: () => void;
  onPreview: (keys: string[]) => void;
}) {
  const resettable = useMemo(() => settings.filter((setting) => (
    setting.resettable !== false && setting.secret !== true && setting.defaultValue !== undefined
  )), [settings]);
  const [selected, setSelected] = useState<string[]>([]);

  useEffect(() => {
    if (open) {
      setSelected(resettable.map((setting) => setting.key));
    }
  }, [open, resettable]);

  const selectedSet = new Set(selected);
  const toggleKey = (key: string, checked: boolean) => {
    setSelected((current) => checked ? [...new Set([...current, key])] : current.filter((entry) => entry !== key));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`Скинути defaults: ${targetTitle}`}
      primaryAction={{
        content: busy ? 'Готую preview...' : 'Перевірити скидання',
        onAction: () => onPreview(selected),
        loading: Boolean(busy),
        disabled: selected.length === 0,
      }}
      secondaryActions={[{ content: 'Скасувати', onAction: onClose }]}
    >
      <Modal.Section>
        <div className="admin-stack">
          <Text as="p" variant="bodyMd" tone="subdued">
            Оберіть тільки ті налаштування, які треба повернути до стандартного production-набору. Секрети LiqPay тут не скидаються.
          </Text>
          <div className="admin-reset-list">
            {resettable.map((setting) => (
              <label className="admin-reset-list__item" key={setting.key}>
                <Checkbox
                  label={setting.label}
                  checked={selectedSet.has(setting.key)}
                  onChange={(checked) => toggleKey(setting.key, checked)}
                />
                <span>{setting.description}</span>
                <code>{setting.key} = {String(setting.defaultValue)}</code>
              </label>
            ))}
          </div>
        </div>
      </Modal.Section>
    </Modal>
  );
}
